<template>
  <div
    class="w-full md:w-30rem textPrimary flex flex-column align-items-center justify-content-center"
  >
    <h2 class="text-center">Modifique los datos de la Sub-categoría</h2>
    <div class="w-2 mb-3 blue-line"></div>

    <div v-if="loading" class="spinner-wrapper">
      <ProgressSpinner style="width: 50px; height: 50px" />
    </div>

    <div v-else>
      <div class="w-full flex flex-column gap-4">
        <div class="flex flex-column align-items-start gap-2">
          <label for="categoria">Seleccione una categoría </label>
          <Dropdown
            id="categoria"
            v-model="subcategoria.id_categoria"
            :options="categorias"
            @change="changeDropdown"
            optionLabel="Nombre"
            optionValue="CategoriaID"
            :filter="true"
            class="w-full input-border-blue"
          />
        </div>
        <div class="flex flex-column align-items-start gap-2">
          <label for="nombre">Ingrese el nombre</label>
          <InputText
            v-no-emoji
            id="nombre"
            v-model="subcategoria.nombre"
            class="w-full input-border-blue"
          />
        </div>
      </div>

      <div class="mt-5 flex justify-content-end gap-2">
        <Button label="Cancelar" @click="handleCancel" class="cancelar-button" />
        <Button
          label="Confirmar"
          :icon="isSaving ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
          @click="handleSave"
          :disabled="isSaving"
          class="custom-action-button"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onBeforeMount, defineComponent } from "vue";
import { useStoreCompat } from "@/composables/useStoreCompat.js";
import { useRest } from "@/composables/useRest";

export default defineComponent({
  name: "SubcategoriaForm",
  props: {
    subcategoriaData: Object,
  },
  emits: ["close", "openModalsuccess"],
  setup(props, { emit }) {
    const store = useStoreCompat();
    const rest = useRest();

    const modalSuccess = ref(null);
    const subcategoria = ref({
      nombre: props.subcategoriaData?.Nombre || "",
      categoria: props.subcategoriaData?.categoria || "",
      id_categoria: props.subcategoriaData?.id_categoria || null,
    });

    const loading = ref(true);
    const isSaving = ref(false);
    const subcategoriaID = ref(props.subcategoriaData.SubcategoriaID);

    const categorias = computed(() => store.state.siis.categoriasDeposito);

    const changeDropdown = (event) => {
      const selected = event.value;
      const found = categorias.value.find((sub) => sub.CategoriaID === selected);
      subcategoria.value.categoria = found?.Nombre || "";
      subcategoria.value.id_categoria = found?.CategoriaID || null;
    };

    const handleSave = async () => {
      isSaving.value = true;
      try {
        await rest.put({
          url: `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/parametros/sub-categorias/${subcategoriaID.value}`,
          formData: {
            Nombre: subcategoria.value.nombre,
            id_categoria: subcategoria.value.id_categoria,
          },
        });
        emit("openModalsuccess", {
          title: "Los datos de la subcategoría fueron editados",
          message: "Ahora se veran reflejados tus nuevos datos en la tabla",
        });
        emit("close");
      } catch (err) {
        console.error("Error al guardar:", err);
      } finally {
        isSaving.value = false;
      }
    };

    const handleCancel = () => {
      emit("close");
    };

    onBeforeMount(async () => {
      await store.dispatch("siis/setSubCategoriasDeposito");
      await store.dispatch("siis/setCategoriasDeposito");
      loading.value = false;
    });

    return {
      //refs
      modalSuccess,
      subcategoria,
      loading,
      isSaving,
      //computetd
      categorias,
      //methods
      handleSave,
      changeDropdown,
      handleCancel,
    };
  },
});
</script>

<style scoped>
.textPrimary {
  color: #111928;
}

.blue-line {
  height: 4px;
  background-color: #0b5195;
  border-radius: 9999px;
}

.custom-action-button {
  display: flex;
  width: 124px;
  height: 36px;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 6px;
  background-color: var(--Primary, #0b5195);
  color: white;
  border: none;
}

.custom-action-button:hover {
  opacity: 0.9;
  cursor: pointer;
}

.cancelar-button {
  display: flex;
  width: 124px;
  height: 36px;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 6px;
  background: var(--White-White, #fff);
  color: #0b5195;
  border: none;
  box-shadow: 0px 1px 3px 0px rgba(166, 175, 195, 0.4);
}

.cancelar-button:hover {
  background: #f4f4f4 !important;
  color: #0b5195 !important;
  opacity: 0.9;
  cursor: pointer;
}

.input-border-blue {
  border: 2px solid #0b5195;
  border-radius: 6px;
  width: 100%;
  transition: border 0.2s ease;
}
</style>
